type StyleStore = Map<string, string>;
const store = new WeakMap<HTMLElement, StyleStore>();

interface ApplyStylePreservingInlineParams {
  element: HTMLElement;
  enabled: boolean;
  styleProperty: string;
  getValue: () => string | null;
}

export function applyStylePreservingInline({
  element,
  enabled,
  styleProperty,
  getValue
}: ApplyStylePreservingInlineParams) {
  const styleStore = store.get(element);

  if (!enabled) {
    const originalInline = styleStore?.get(styleProperty);
    if (originalInline === undefined) {
      return;
    }

    element.style.setProperty(styleProperty, originalInline);

    if (styleStore) {
      styleStore.delete(styleProperty);
    }

    return;
  }

  if (!styleStore?.has(styleProperty)) {
    const nextStore = styleStore ?? new Map();
    if (!styleStore) {
      store.set(element, nextStore);
    }

    nextStore.set(styleProperty, element.style.getPropertyValue(styleProperty));
  }

  element.style.setProperty(styleProperty, getValue());
}
